/**
 * 盤點掃碼提示音（Web Audio 合成，無 mp3）。
 * duplicate／notFound 音色不同；失敗一律 swallow（瀏覽器自動播放限制等）。
 */

function createAudioContext() {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) {
    return null;
  }
  return new AudioCtx();
}

function playTone(ctx, {
  frequency,
  durationSec,
  type = 'sine',
  gainValue = 0.12,
  startAt = 0,
}) {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = type;
  oscillator.frequency.value = frequency;
  gain.gain.value = 0;
  oscillator.connect(gain);
  gain.connect(ctx.destination);

  const t0 = ctx.currentTime + startAt;
  gain.gain.setValueAtTime(0, t0);
  gain.gain.linearRampToValueAtTime(gainValue, t0 + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.001, t0 + durationSec);

  oscillator.start(t0);
  oscillator.stop(t0 + durationSec + 0.02);
}

/**
 * @param {'duplicate'|'notFound'} kind
 */
export function playStocktakeScanSound(kind) {
  try {
    const ctx = createAudioContext();
    if (!ctx) {
      return;
    }

    const resume = ctx.state === 'suspended' ? ctx.resume() : Promise.resolve();
    resume.then(() => {
      if (kind === 'duplicate') {
        // 短促雙音（中音 → 稍低）
        playTone(ctx, {
          frequency: 660,
          durationSec: 0.09,
          type: 'triangle',
          gainValue: 0.1,
        });
        playTone(ctx, {
          frequency: 440,
          durationSec: 0.12,
          type: 'triangle',
          gainValue: 0.08,
          startAt: 0.1,
        });
        return;
      }

      if (kind === 'notFound') {
        // 較長低沉下行音
        playTone(ctx, {
          frequency: 320,
          durationSec: 0.18,
          type: 'sawtooth',
          gainValue: 0.09,
        });
        playTone(ctx, {
          frequency: 220,
          durationSec: 0.22,
          type: 'sawtooth',
          gainValue: 0.07,
          startAt: 0.14,
        });
      }
    }).catch(() => {});
  } catch {
    // swallow
  }
}
